
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  Button,
  TextField,
  Grid,
  Paper,
  IconButton,
  Stack,
  MenuItem,
  ToggleButtonGroup,
  ToggleButton,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  PortfolioCreateFund,
  PortfolioUploadDocuments,
} from "../../util/API/portfolio";
import { Snackbar, Alert } from "@mui/material";
import { commonRunQuery } from "../../util/API/loans";
const CreateProductForm = ({ onBack }) => {
  let configVariables = useSelector((state) => state.config.baseConfig);
    let userSecurityRoles = JSON.parse(sessionStorage.getItem("user")).payload
      ?.body?.Securityuserrole;
  const [creationMode, setCreationMode] = useState("investor");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [delegateEntities, setDelegateEntities] = useState([]);
  const [delegateLoading, setDelegateLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "" });
  const [userRole, setUserRole] = useState("admin");
  const user = JSON.parse(sessionStorage.getItem("user")).payload?.body;
  const userId = user?.User?.id || "";
  const userPin = user?.User?.pin || "";

  console.log("userId========", userId);
  console.log("userPin========", userPin);
  
    useEffect(() => {
      // 1. Normalize user roles to an array to handle single or multiple roles
      const userRoles = Array.isArray(userSecurityRoles)
        ? userSecurityRoles
        : [userSecurityRoles];
  
      // 2. Helper to safely parse comma-separated IDs from the Redux config
      const parseConfigIds = (ids) =>
        ids
          ?.toString()
          .split(",")
          .map((id) => Number(id.trim())) || [];
  
      const adminRolesArray = parseConfigIds(
        configVariables?.portfolioAdminRoleIds,
      );
      const delegateRolesArray = parseConfigIds(configVariables?.delegateRoleIds);
  
      // 3. Check membership for Admin and Delegate roles
      const isAdmin = userRoles.some((role) =>
        adminRolesArray.includes(Number(role?.roleid)),
      );
  
      const isDelegate = userRoles.some((role) =>
        delegateRolesArray.includes(Number(role?.roleid)),
      );
  
      // 4. Set role dynamically based on priority
      if (isAdmin) {
        setUserRole("admin");
      } else if (isDelegate) {
        setUserRole("delegate");
      } else {
        setUserRole("investor");
      }
    }, [userSecurityRoles, configVariables]);
  
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    total_fund_size: "",
    minimum_ticket_size: "",
    target_multiple: "",
    target_yearly_return: "",
    associated_video_url: "",
    start_date: "",
    end_date: "",
    visibility: "public",
    selectedEntityId: null,
  });

  const mockEntities = [
    { id: 501, name: "Family Office Alpha" },
    { id: 502, name: "Global Tech Holdings" },
  ];

  const handleFileChange = (e) => {
    const uploadedFiles = Array.from(e.target.files);
    setFiles([...files, ...uploadedFiles]);
  };

  const removeFile = (index) => {
    setFiles(files.filter((_, i) => i !== index));
  };
  const getDelegateEntities = async () => {
    setDelegateLoading(true);
    try {
      const response = await commonRunQuery(370, userId);
      console.log(
        "Delegate Entities Response ============",
        JSON.stringify(response),
      );

      const record = response?.data?.body?.record;

      if (record) {
        // Normalize: single object or array
        const recordsArray = Array.isArray(record) ? record : [record];

        const mapped = recordsArray.map((item) => {
          const u = item.u;
          const uea = item.uea;
          return {
            id: u.investor_id,
            name: `${u.investor_firstName} ${u.investor_lastName}`,
            email: uea.investor_email,
          };
        });

        setDelegateEntities(mapped);
      }
    } catch (error) {
      console.error("getDelegateEntities error:", error);
    } finally {
      setDelegateLoading(false);
    }
  };
  const handleLaunchFund = async () => {
    setError("");

    // Validate required fields
    if (
      !formData.name ||
      !formData.total_fund_size ||
      !formData.minimum_ticket_size ||
      !formData.start_date
      // !formData.end_date
    ) {
      setError(
        "Please fill in all required fields: Fund Name, Total Fund Size, Min. Ticket Size, Start Date, End Date.",
      );
      return;
    }

    setLoading(true);
    let createdBy = null;
    let createdFor = null;
    if (creationMode === "delegate") {
      createdBy = userId;
      createdFor = formData.selectedEntityId;
    } else {
      createdBy = userId;
      createdFor = userId;
    }
    try {
      // Step 1 — Create the fund
      const fundResponse = await PortfolioCreateFund(
        formData.name,
        formData.description,
        createdBy, // was createdFor — should be the acting user
        userRole,
        formData.total_fund_size,
        formData.minimum_ticket_size,
        formData.target_multiple,
        formData.target_yearly_return,
        formData.associated_video_url,
        formData.start_date,
        formData.end_date,
        formData.visibility,
        createdFor,
      );

      console.log(
        "PortfolioCreateFund full response========",
        JSON.stringify(fundResponse),
      );

      const callStatus =
        fundResponse?.data?.header?.callStatus ||
        fundResponse?.payload?.callStatus;

      if (callStatus !== "1" && callStatus !== 1) {
        setError(
          fundResponse?.payload?.msg ||
            "Fund creation failed. Please try again.",
        );
        setLoading(false);
        return;
      }

      const newFundId = fundResponse?.data?.header?.fundId;

      console.log("New Fund ID========", newFundId);

      if (!newFundId) {
        setError(
          "Fund created but documents could not be uploaded — Fund ID missing in response.",
        );
        setLoading(false);
        return;
      }

      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          console.log(
            `Uploading document ${i + 1}/${files.length}: ${file.name}`,
          );

          const uploadResponse = await PortfolioUploadDocuments(
            newFundId,
            formData.name,
            file, // file object
            "public", // access_role
            userId, // userid
            userPin, // userpin
          );

          console.log(
            `Upload response for ${file.name}:`,
            JSON.stringify(uploadResponse),
          );

          // Check each upload
          const uploadStatus =
            uploadResponse?.data?.header?.callStatus ||
            uploadResponse?.payload?.callStatus;
          if (uploadStatus !== "1" && uploadStatus !== 1) {
            console.warn(`Upload failed for ${file.name}:`, uploadResponse);
          }
        }
      }

      setSnackbar({
        open: true,
        message: `Fund "${formData.name}" launched successfully!`,
      });
      setTimeout(() => {
        setSnackbar({ open: false, message: "" });
        onBack();
      }, 3000);
    } catch (err) {
      console.error("handleLaunchFund error========", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 1000, mx: "auto", mt: 4, p: 2, pb: 10 }}>
      <Box display="flex" alignItems="center" gap={2} mb={3}>
        <IconButton onClick={onBack}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5" fontWeight="bold" color="#002e4c">
          Launch New Investment Fund
        </Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError("")}>
          {error}
        </Alert>
      )}

      <Grid container spacing={3}>
        {/* TOP SECTION: Creation Mode */}
        <Grid item xs={12}>
          <Paper className="dashboard-card" sx={{ p: 3, bgcolor: "#f0f4f8" }}>
            <Typography variant="subtitle2" gutterBottom>
              I am creating this fund as:
            </Typography>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              alignItems="center"
            >
              <ToggleButtonGroup
                value={creationMode}
                exclusive
                onChange={(e, val) => {
                  if (!val) return;
                  setCreationMode(val);
                  if (val === "delegate") getDelegateEntities(); //  fetch on switch
                }}
                size="small"
                color="primary"
              >
                <ToggleButton value="investor" sx={{ px: 3 }}>
                  Individual Investor
                </ToggleButton>
                <ToggleButton value="delegate" sx={{ px: 3 }}>
                  On Behalf of Entity (Delegate)
                </ToggleButton>
              </ToggleButtonGroup>

              {creationMode === "delegate" && (
                <Autocomplete
                  options={delegateEntities}
                  getOptionLabel={(option) =>
                    `${option.name} (${option.email})`
                  }
                  loading={delegateLoading}
                  sx={{ width: 300 }}
                  onChange={(e, val) =>
                    setFormData({
                      ...formData,
                      selectedEntityId: val?.id || null,
                    })
                  }
                  renderOption={(props, option) => (
                    <Box component="li" {...props}>
                      <Box>
                        <Typography variant="body2" fontWeight="600">
                          {option.name}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {option.email}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Entity"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {delegateLoading ? (
                              <CircularProgress color="inherit" size={16} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              )}
            </Stack>
          </Paper>
        </Grid>

        {/* Left Side: Fund Details */}
        <Grid item xs={12} md={7}>
          <Paper className="dashboard-card" sx={{ p: 3 }}>
            <Typography variant="h6" mb={2}>
              Fund Configuration
            </Typography>
            <Stack spacing={2.5}>
              <TextField
                fullWidth
                label="Fund Name *"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />

              <Grid
                container
                spacing={2}
                sx={{
                  gap: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Grid
                  item
                  xs={5.5}
                  sx={{
                    paddingLeft: "0px !important",
                    paddingTop: "0px !important",
                  }}
                >
                  <TextField
                    fullWidth
                    label="Total Fund Size ($) *"
                    type="number"
                    value={formData.total_fund_size}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        total_fund_size: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid
                  item
                  xs={5.5}
                  sx={{
                    paddingLeft: "0px !important",
                    paddingTop: "0px !important",
                  }}
                >
                  <TextField
                    fullWidth
                    label="Min. Ticket Size ($) *"
                    type="number"
                    value={formData.minimum_ticket_size}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        minimum_ticket_size: e.target.value,
                      })
                    }
                  />
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                sx={{
                  gap: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Grid
                  item
                  xs={5.49}
                  sx={{
                    paddingLeft: "0px !important",
                    paddingTop: "0px !important",
                  }}
                >
                  <TextField
                    fullWidth
                    label="Target IRR (%)"
                    placeholder="e.g. 15.5"
                    value={formData.target_yearly_return}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        target_yearly_return: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid
                  item
                  xs={5.49}
                  sx={{
                    paddingLeft: "0px !important",
                    paddingTop: "0px !important",
                  }}
                >
                  <TextField
                    fullWidth
                    label="Target Multiple (x)"
                    placeholder="e.g. 2.5"
                    value={formData.target_multiple}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        target_multiple: e.target.value,
                      })
                    }
                  />
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                sx={{
                  gap: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Grid
                  item
                  xs={5.49}
                  sx={{
                    paddingLeft: "0px !important",
                    paddingTop: "0px !important",
                  }}
                >
                  <TextField
                    fullWidth
                    label="Start Date *"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={formData.start_date}
                    onChange={(e) =>
                      setFormData({ ...formData, start_date: e.target.value })
                    }
                  />
                </Grid>
                <Grid
                  item
                  xs={5.49}
                  sx={{
                    paddingLeft: "0px !important",
                    paddingTop: "0px !important",
                  }}
                >
                  <TextField
                    fullWidth
                    label="End Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={formData.end_date}
                    onChange={(e) =>
                      setFormData({ ...formData, end_date: e.target.value })
                    }
                  />
                </Grid>
              </Grid>

              <TextField
                select
                fullWidth
                label="Visibility"
                value={formData.visibility}
                onChange={(e) =>
                  setFormData({ ...formData, visibility: e.target.value })
                }
              >
                <MenuItem value="public">Public (Marketplace)</MenuItem>
                <MenuItem value="private">Private (Invite Only)</MenuItem>
              </TextField>

              <TextField
                fullWidth
                label="Video Presentation URL"
                placeholder="YouTube or Vimeo Link"
                value={formData.associated_video_url}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    associated_video_url: e.target.value,
                  })
                }
              />

              <TextField
                fullWidth
                multiline
                rows={4}
                label="Fund Description"
                value={formData.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
              />
            </Stack>
          </Paper>
        </Grid>

        {/* Right Side: Document Upload */}
        <Grid item xs={12} md={5}>
          <Paper className="dashboard-card" sx={{ p: 3 }}>
            <Typography variant="h6" mb={2}>
              Offering Documents
            </Typography>
            <Box
              sx={{
                border: "2px dashed #ccc",
                borderRadius: 2,
                p: 3,
                textAlign: "center",
                bgcolor: "#fafafa",
                cursor: "pointer",
              }}
              component="label"
            >
              <input type="file" hidden multiple onChange={handleFileChange} />
              <CloudUploadIcon sx={{ fontSize: 40, color: "#90a4ae", mb: 1 }} />
              <Typography variant="body2">Upload PPM or Pitch Deck</Typography>
              <Typography variant="caption" color="textSecondary">
                Click to browse files
              </Typography>
            </Box>

            <Box mt={2}>
              {files.length === 0 && (
                <Typography variant="caption" color="textSecondary">
                  No documents uploaded yet.
                </Typography>
              )}
              {files.map((file, index) => (
                <Box
                  key={index}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{
                    p: 1,
                    mb: 1,
                    borderRadius: 1,
                    bgcolor: "#f8f9fa",
                    border: "1px solid #eee",
                  }}
                >
                  <Typography variant="caption" noWrap sx={{ maxWidth: "80%" }}>
                    {file.name}
                  </Typography>
                  <IconButton size="small" onClick={() => removeFile(index)}>
                    <DeleteIcon color="error" fontSize="inherit" />
                  </IconButton>
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid>

        {/* Action Buttons */}
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button variant="outlined" onClick={onBack} disabled={loading}>
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={loading}
              sx={{
                bgcolor: "#002e4c",
                px: 4,
                "&:hover": { bgcolor: "#004a7a" },
              }}
              onClick={handleLaunchFund}
            >
              {loading ? (
                <>
                  <CircularProgress size={18} color="inherit" sx={{ mr: 1 }} />{" "}
                  Launching...
                </>
              ) : (
                "Confirm & Launch Fund"
              )}
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ open: false, message: "" })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ open: false, message: "" })}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateProductForm;


